import React from 'react'
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { useGetItemTaxTemplateByNameQuery } from '../../../../store/api/itemtaxapi';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from './Tab2';
import Attachment from '../../../../utils/Attachment';
function Itemtax() {
  const location = useLocation()
  const taxId = location?.state.taxId
  const [tab, settab] = useState(1)
  const [res, setRes] = useState(false)
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [status, setStatus] = useState(false)
  const [formdata, setFormData] = useState({
    title: '', company: "", gst_treatment: "", gst_rate: ""
  })
  const [itemtax, setItemtax] = useState('')
  const [selectedTaxAccounts, setSelectedTaxAccounts] = useState([]);
  const { data: itemdata, iserror, isLoading } = useGetItemTaxTemplateByNameQuery(taxId)
  useEffect(() => {
    if (itemdata?.data) {
      const { name, company, gst_treatment, gst_rate, title } = itemdata.data;
      setItemtax(itemdata.data);
      setSelectedTaxAccounts(itemdata.data.taxes)
      setFormData({
        title: title || name,
        company: company || "",
        gst_treatment: gst_treatment || "",
        gst_rate: gst_rate || 0,
      });
    }
  }, [itemdata]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'gst_rate' ? Number(value) : value,
    }));
  };
  return (
    <>
      <FormLayoutTwo
        title="View Item Tax Template"
        breadcrumbs={[
          { label: "Item Tax Template" },
          { label: "Item Tax Template List ", url: "/master/itemtax/item-tax-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>
            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="#">
                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
               <Attachment doctype="Item Tax Template"  docname={taxId}  /> 
            </div>
          </div>
            <div className=" " style={{ background: '' }}>
                              <div className="row">
                                <div className="col-12">
                                  <div >
                                    <Tab1 formdata={formdata} setFormData={setFormData} handleChange={handleChange} selectedTaxAccounts={selectedTaxAccounts} taxId={taxId}   />
                                  </div>
                                </div>
                              </div>
                            </div>    

        
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayoutTwo>
    </>
  )
}
export default Itemtax
